
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import { cp, cc } from 'backend/hops';
import { gs } from 'backend/hops';

const isMobile = wixWindow.formFactor === 'Mobile';

$w.onReady(function () {
    if (!isMobile) {
        $w('#ptHoverButton').onMouseIn(() => {
            $w('#ptRegularState').hide();
            $w('#ptHoverState').show();
        })
        $w('#ptHoverButton').onMouseOut(() => {
            $w('#ptRegularState').show();
            $w('#ptHoverState').hide();
        })
    }

    /////////////////////////////////////////////////////////////////////////////////
    // The following code is an unabashed kludge.
    //   - show the wishlist box at the bottom of the Forum Category page
    //   - hide the wishlist box wnen on any other "page" of the Forum app
    //
    // Depending on how redirection and the forum pages work, the path index for
    // this little bit of nonsense might have to be adjusted. Until Feb 8, 20200
    // it was checking path[1] when it was discovered that the "forum" path now
    // appears in the first element of the path array - path[0].
    // I fixed it and had a beer.
    //
    $w('#box1').collapse();

    let path = wixLocation.path;
    console.log('path', path);
    if (path[0] === 'forum' && path.length === 1) {
        $w('#box1').expand();
    } else {
        $w('#box1').collapse();
    }

    wixLocation.onChange((location) => {
        let newPath = location.path;
        console.log('newPath', newPath);
        if (newPath[0] === 'forum' && newPath.length === 1) {
            $w('#box1').expand();
        } else {
            $w('#box1').collapse();
        }
    });
    //
    // No apologies - it works. I'm not in the least ashamed.
    /////////////////////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////
    // these event handlers copied to Live Forum onReady()
    //
    $w('#forumApp').onBeforePostCreate(p => {
        return cp(p).then(res => {
            return res;
        });
    })
    $w('#forumApp').onBeforeCommentCreate(c => {
        return cc(c, c.content).then(res => {
            return res;
        });
    })
    $w('#forumApp').onBeforePostUpdate(p => {
        return cp(p).then(res => {
            return res;
        });
    })
    $w('#forumApp').onBeforeCommentUpdate(c => {
        return cc(c, c).then(res => {
            return res;
        });
    })

    $w('#forumApp').onFetchExternalLinks( (data) => {
        return gs(data).then(res => {
        	return res['items'];
        });
    })    
});